'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('SsoReturnCtrl', SsoReturnCtrl);

  SsoReturnCtrl.$inject = ['$sessionStorage', 'authenticationSvc', 'windowSvc', 'loadingScreenSvc', 'onboardingRouter', 'ssoIdView'];

  function SsoReturnCtrl($sessionStorage, authenticationSvc, windowSvc, loadingScreenSvc, onboardingRouter, ssoIdView) {
    var vm = this;
    vm.ssoIdView = ssoIdView;
    _init();

    function _init() {
      var orgName = _resolveOrgNameFromUser($sessionStorage.user);
      if (ssoIdView.redirectUrl) {
        $sessionStorage.redirectUrl = ssoIdView.redirectUrl;
      }
      if ($sessionStorage.user) {
        loadingScreenSvc.createLoadingScreen(orgName, onboardingRouter.goToNextStep);
        return;
      }

      loadingScreenSvc.createLoadingScreen(orgName, function () {});
      authenticationSvc.ssoMapAndLogin(vm.ssoIdView).then(_onSuccess, _onError);
    }

    function _onSuccess(resp) {
      var user = resp.data.response;
      var orgName = _resolveOrgNameFromUser(user);

      if (user.clientOfferingVersion && user.clientOfferingVersion === 'BH2_0') {
        windowSvc.goToAppV2OnboardingLanding();
        return;
      }

      onboardingRouter.removeLoginStep();
      loadingScreenSvc.removeLoadingScreen();
      loadingScreenSvc.createLoadingScreen(orgName, onboardingRouter.goToNextStep);
    }

    function _onError() {
      onboardingRouter.navigateSsoError();
    }

    function _resolveOrgNameFromUser(user) {
      return user && user.organization && user.organization.name ? user.organization.name : 'myStrength';
    }
  }
})();